module.exports = __webpack_public_path__ + "img/persona dreamdeal tech (3)-26.d0088ed5.jpg";